









































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import SwitchForm from '@/reusable/Form/SwitchForm.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import HandleErrors from '@/config/handleErrors';
import {
  emitFormChangeEvent,
  FormChangeEvent,
  formErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Taller } from './Taller';
import { Snotify } from '@/snotify/Snotify';
import { EstadoEntidad } from '../../config/enums';
import ValidaRut from '@/config/validaRut';
import CampoUnico, { uniqueFieldRule } from '@/reusable/Form/CampoUnico.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

import { fetchTallerUnico } from '@/pantallas/Taller/fetchTallerUnico';

@Component({
  components: { TextField, FormFieldsContainer, CampoUnico },
})
export default class TallerForm extends Vue {
  @Prop() tallerSeleccionado: Taller;
  @Prop({ default: true }) editarTaller: boolean;
  @Prop({ default: true }) verTaller: boolean;
  @Prop({ default: '' }) direccionAutoCompleteGoogle: string;

  isFormValid: boolean = false;
  readonly $snotify: Snotify;
  totalAsociados: number = 0;

  estadoSwitch: boolean = true;
  mensajeEstado: string = '';

  vr: ValidaRut = new ValidaRut();
  uniqueFieldRule = uniqueFieldRule;

  formFields: FormFieldDefMap = {
    activo: {
      label: 'Activo',
      id: 'activo',
      value: 'false',
    },
    rut: {
      label: 'Rut',
      id: 'rut',
      value: '',
    },
    nombre: {
      label: 'Nombre o Razón Social',
      id: 'nombre',
      value: '',
    },
    descripcion: {
      label: 'Descripción',
      id: 'descripcion',
      value: '',
    },
    giro: {
      label: 'Giro',
      id: 'giro',
      value: '',
    },
    direccion: {
      label: 'Dirección',
      id: 'direccion',
      value: '',
    },
    latitud: {
      label: '',
      id: 'latitud',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));

    let r = this.vr;

    Validator.extend('rut', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.Rut(value),
            data: r.Rut(value)
              ? undefined
              : {
                  message: '* Rut inválido',
                },
          });
        });
      },
    });

    Validator.extend('rutFormato', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* Rut inválido';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.validaFormatoRut(value),
            data: r.validaFormatoRut(value)
              ? undefined
              : { message: '* Rut inválido' },
          });
        });
      },
    });

    this.handleFormChange();
  }

  @Watch('tallerSeleccionado', { deep: true, immediate: true })
  handleTallerSeleccionadoChange() {
    if (!this.tallerSeleccionado) {
      this.totalAsociados = 0;
      return;
    }
    this.formFields.rut.value = this.tallerSeleccionado.rut;
    this.formFields.nombre.value = this.tallerSeleccionado.nombre;
    this.formFields.descripcion.value = this.tallerSeleccionado.descripcion;
    this.formFields.giro.value = this.tallerSeleccionado.giro;
    this.formFields.activo.value =
      this.tallerSeleccionado.estado == EstadoEntidad.Activo ? true : false;
    this.formFields.direccion.value = this.tallerSeleccionado.direccion;
    this.totalAsociados = this.tallerSeleccionado.totalAsociados;
    this.cambioEstadoSwitch(this.formFields.activo.value);
  }

  @Watch('$validator.errors.items.length')
  handleErrorsChange() {
    this.emitFormChange();
  }

  emitFormChange() {
    emitFormChangeEvent(
      this.$emit.bind(this),
      {
        entity: {
          rut: this.formFields.rut.value,
          nombre: this.formFields.nombre.value,
          descripcion: this.formFields.descripcion.value,
          giro: this.formFields.giro.value,
          estado: this.formFields.activo.value
            ? EstadoEntidad.Activo
            : EstadoEntidad.Inactivo,
        } as Taller,
      },
      this
    );
  }

  @Watch('formFields', { deep: true })
  handleFormChange() {
    this.emitFormChange();
  }

  @Watch('formFields.direccion', { deep: true })
  handleFormFieldDireccion() {
    this.$emit('handleFormFieldDireccion', this.formFields.direccion.value);
  }

  @Watch('direccionAutoCompleteGoogle', { deep: true, immediate: true })
  handleChangeDireccion() {
    if (this.direccionAutoCompleteGoogle) {
      const { direccion } = this.formFields;
      direccion.value = this.direccionAutoCompleteGoogle;
    }
  }

  cambioEstadoSwitch(isActivo: boolean) {
    //this.fields[this.formFields.activo.id].dirty = true;
    this.handleFormChange();
    if (isActivo) {
      this.mensajeEstado = '';
      this.formFields.activo.label = 'Activo';
    } else {
      if (this.totalAsociados === 0) {
        this.mensajeEstado =
          'Al dejar como inactivo, no se podrán realizar asociaciones.';
      }
      this.formFields.activo.label = 'Inactivo';
    }
    this.$emit('estadoSwitch', isActivo);
  }

  validarRutRegistrado(rut: string) {
    const axios = new AxiosVue(ServicioProxy.Mantenimiento);
    const id =
      this.tallerSeleccionado === undefined ? 0 : this.tallerSeleccionado.id;
    return axios.http.get(`TallerMant/ChequearNombreUnico/${id}/${rut}/`);
  }
}
